export const APP_NAME = 'TradeYönetim';

export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  PRODUCTS: '/products',
  SALES: '/sales',
  ANALYSIS: '/analysis',
  PRICE_CHANGE_AND_ALERT: '/price-change-and-alert',
  LOGS: '/logs',
  ADMIN: '/admin',
  ADMIN_LOGS: '/admin/logs',
  ADMIN_METRICS: '/admin/metrics',
} as const;

export const COLORS = {
  PRIMARY: '#0d71c1',
  SIDEBAR_DARK: '#393e46',
  BACKGROUND: '#252a34',
  TEXT_LIGHT: '#ffffff',
  TEXT_DARK: '#000000',
} as const;
